// extracted by mini-css-extract-plugin
export default {"nav":"UserAccountNav_nav__lBUuz","navLink":"UserAccountNav_navLink__ToCJs"};